import { render, staticRenderFns } from "./FeedbackEmail.vue?vue&type=template&id=61ece7e1&slot-scope=props&"
import script from "./FeedbackEmail.vue?vue&type=script&lang=js&"
export * from "./FeedbackEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports